import { ref } from "vue";
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useJustificationItem() {
    const showModalRefusAnomalie = ref(false);
    const showComments = ref({});
    const editComments = ref({});
    const commentaire = ref('Refus de la justification');

    const toggleComment = (id) => {
        showComments.value[id] = !showComments.value[id];
    };

    const toggleEdit = (id) => {
        editComments.value[id] = !editComments.value[id];
    };

    const ValidJustif = async (valid, commentaireText, idLigneAnomalie) => {
        try {
            const data = await http.validJustif(valid, commentaireText, idLigneAnomalie);
            idLigneAnomalie = data;

            eventBus.emit('reloadAnomalies');
            eventBus.emit('reloadRapport');
        } catch (error) {
            console.error("Erreur lors de la validation de la justification", error);
        }
    };

    return {
        showModalRefusAnomalie,
        showComments,
        editComments,
        toggleComment,
        toggleEdit,
        commentaire,
        ValidJustif,
    };
}
